import styled from 'styled-components/macro';

export default styled.div`
 padding: 60px 0;
`